import theme from '../../../theme';

// The swatches a map legend draws — line, dashed line, faint gap connector,
// gap diamond, stop discs, driver chevron — keyed by a class prefix so the
// Single-route and Global panes share one block under their own prefixes
// (`rmp-` / `gmp-`) without their selectors cascading into each other.
export default function legendStyles(prefix) {
  return {
    [`& .${prefix}-legend`]: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      rowGap: theme.spacing.gapMd,
      columnGap: theme.spacing.fieldGap,
      padding: `${theme.spacing.gapMd} ${theme.spacing.fieldGap} ${theme.spacing.gapLg}`,
      borderBottom: `1px solid ${theme.colors.borderLight}`,
      fontSize: theme.sizes.captionFontSize,
      color: theme.colors.textMuted,
    },
    [`& .${prefix}-legend-item`]: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing.gapSm,
    },
    [`& .${prefix}-swatch-line`]: {
      width: theme.sizes.iconLg,
      borderTopWidth: '3px',
      borderTopStyle: 'solid',
      borderTopColor: theme.colors.routeLine,
    },
    [`& .${prefix}-swatch-line.dashed`]: {
      borderTopStyle: 'dashed',
      borderTopColor: theme.colors.markerInk,
    },
    [`& .${prefix}-swatch-line.faint`]: {
      borderTopWidth: theme.sizes.legendLineWidth,
      borderTopStyle: 'dotted',
      opacity: theme.opacities.faint,
    },
    [`& .${prefix}-swatch-line.other-driver`]: {
      borderTopWidth: theme.sizes.legendLineWidth,
      borderTopStyle: 'dotted',
      borderTopColor: theme.colors.statusOutOfSequence,
    },
    // The hollow diamond that marks a GPS gap on the map (makeGapIcon).
    [`& .${prefix}-swatch-diamond`]: {
      width: theme.sizes.iconXs,
      height: theme.sizes.iconXs,
      boxSizing: 'border-box',
      background: theme.colors.white,
      border: `${theme.sizes.legendLineWidth} solid ${theme.colors.routeLine}`,
      transform: 'rotate(45deg)',
      flexShrink: 0,
    },
    // The hollow ring at a trail's first reading (makeTrailStartIcon).
    [`& .${prefix}-swatch-ring`]: {
      width: theme.sizes.iconSm,
      height: theme.sizes.iconSm,
      boxSizing: 'border-box',
      borderRadius: theme.radii.circle,
      background: theme.colors.white,
      border: `${theme.sizes.legendLineWidth} solid ${theme.colors.routeLine}`,
      flexShrink: 0,
    },
    // Dots mirror the stop discs: green stocked, ink otherwise.
    [`& .${prefix}-swatch-dot`]: {
      width: theme.sizes.iconSm,
      height: theme.sizes.iconSm,
      borderRadius: theme.radii.circle,
      background: theme.colors.markerInk,
      boxSizing: 'border-box',
      flexShrink: 0,
    },
    [`& .${prefix}-swatch-dot.stocked`]: {
      background: theme.colors.stopStocked,
    },
    [`& .${prefix}-swatch-dot.hollow`]: {
      background: theme.colors.white,
      border: `2px solid ${theme.colors.markerInk}`,
    },
    [`& .${prefix}-swatch-dot.skipped`]: {
      background: theme.colors.statusOffTrackBg,
      border: `1px solid ${theme.colors.statusOffTrack}`,
    },
    [`& .${prefix}-swatch-dot.pulse`]: {
      animation: 'mt-halo-pulse 2.2s ease-in-out infinite',
    },
    [`& .${prefix}-swatch-chevron`]: {
      width: theme.sizes.iconSm,
      height: theme.sizes.iconSm,
      fill: theme.colors.statusOffTrack,
      flexShrink: 0,
    },
  };
}
